<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <div class="tabs-widget">
        <div class="tab-item active" @click="switchTab('contacts')">
          CONTACTS
        </div>
        <div class="h-spacer"></div>
      </div>
      <div class="tab-options"></div>
    </div>
    <div class="wrapper-body">
      <div v-if="!loading_contacts && contacts_data" class="left-panel">
        <div class="table-widget">
          <table>
            <tr>
              <th>Names</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Company</th>
              <th>Message</th>
              <th>Status</th>
              <th>Date</th>
              <th></th>
            </tr>
            <tr v-for="(item, index) in contacts_data" :key="index">
              <td>{{ item.first_name + " " + item.last_name }}</td>
              <td>{{ item.email }}</td>
              <td>{{ item.phone }}</td>
              <td>{{ item.company }}</td>
              <td>{{ item.message }}</td>
              <td>
                <b-tag v-if="item.status == 'confirmed'" type="is-success">CONFIRMED</b-tag>
                <b-tag v-if="item.status == 'pending'" type="is-default">PENDING</b-tag>
                <b-tag v-if="item.status == 'rejected'" type="is-danger">REJECTED</b-tag>
              </td>
              <td>
                {{ moment(item.created_at).format("MMM DD YYYY HH:mm A") }}
              </td>
              <td>
                <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
                  <template #trigger>
                    <b-icon icon="dots-vertical"></b-icon>
                  </template>
                  <b-dropdown-item aria-role="listitem" v-if="item.status != 'pending'"
                    @click="changeStatus(item, 'pending')">Mark as pending</b-dropdown-item>
                  <b-dropdown-item aria-role="listitem" v-if="item.status != 'rejected'"
                    @click="changeStatus(item, 'rejected')">Mark as rejected</b-dropdown-item>
                  <b-dropdown-item v-if="item.status != 'confirmed'" aria-role="listitem"
                    @click="changeStatus(item, 'confirmed')">Mark as confirmed</b-dropdown-item>
                  <b-dropdown-item @click="deleteContacts(item)" aria-role="listitem">Delete</b-dropdown-item>
                </b-dropdown>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div v-if="loading_contacts" class="left-panel">
        <div class="table-widget">
          <table>
            <tr>
              <th>Names</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Company</th>
              <th>Message</th>
              <th>Status</th>
              <th>Date</th>
              <th></th>
            </tr>
            <tr v-for="(item, index) in 15" :key="index">
              <td><b-skeleton width="90%"></b-skeleton></td>
              <td><b-skeleton width="90%"></b-skeleton></td>
              <td><b-skeleton width="90%"></b-skeleton></td>
              <td><b-skeleton width="90%"></b-skeleton></td>
              <td><b-skeleton width="90%"></b-skeleton></td>
              <td><b-skeleton width="90%"></b-skeleton></td>
              <td><b-skeleton width="90%"></b-skeleton></td>
              <td><b-skeleton width="90%"></b-skeleton></td>
            </tr>
          </table>
        </div>
      </div>
      <div class="rigth-panel"></div>
    </div>
    <div class="wrapper-footer"></div>
  </div>
</template>

<script>
export default {
  components: {},
  data: () => ({
    loading_contacts: false,
    contacts_data: null,
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getContacts();
  },
  methods: {
    getContacts() {
      let vm = this;
      vm.loading_contacts = true;
      vm.$store
        .dispatch("ADS_GET_CONTACTS")
        .then((response) => {
          vm.loading_contacts = false;
          vm.contacts_data = response.data.return;
        })
        .catch(({ response }) => {
          vm.loading_contacts = false;
        });
    },
    deleteContacts(item) {
      let vm = this;
      vm.$confirm({
        title: "Confirm",
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm) => {
          if (confirm) {
            vm.$store
              .dispatch("ADS_DELETE_CONTACT", { id: item.id })
              .then((response) => {
                vm.getContacts();
                vm.$notify({
                  group: "status",
                  type: "success",
                  title: "Message",
                  text: response.data.message,
                });
              })
              .catch(({ response }) => {
                vm.$notify({
                  group: "status",
                  type: "warn",
                  title: "OOPS!!!",
                  text: response.data.message,
                });
              });
          }
        },
      });
    },
    changeStatus(item, status) {
      let vm = this;
      vm.$store
        .dispatch("ADS_CHANGE_CONTACT_STATUS", { id: item.id, status: status })
        .then((response) => {
          vm.getContacts();
          vm.$notify({
            group: "status",
            type: "success",
            title: "Message",
            text: response.data.message,
          });
        })
        .catch(({ response }) => {
          vm.$notify({
            group: "status",
            type: "warn",
            title: "OOPS!!!",
            text: response.data.message,
          });
        });
    },
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .wrapper-header {
    width: 100%;
    height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;

    .tabs-widget {
      display: flex;
      align-items: flex-end;

      .h-spacer {
        margin-right: 20px;
      }

      .tab-item {
        cursor: pointer;
        padding: 14px 4px;

        &.active {
          color: var(--wecodefy-secondary-color, #9fc953);
          border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }

    .tab-options {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 10px;

      .h-spacer {
        margin-right: 10px;
      }
    }
  }

  .wrapper-body {
    height: calc(100% - 125px);
    display: flex;

    .left-panel {
      overflow-y: auto;
      height: 100%;
      width: calc(100% - 0px);
      display: flex;
      .table-widget {
        // height: calc(100% - 60px);
        overflow-y: auto;
        border-radius: 0;
        button.openButton {
          display: none;
          width: fit-content;
          margin: 5px 0 0 5px;
          @media (max-width: 600px) {
            display: flex;
          }
        }
        table {
          width: 100%;
          tr {
            th {
              white-space: nowrap;
            }
            td {
              white-space: nowrap;
              .tag-lists {
                display: flex;
                width: fit-content;
                flex-shrink: 0;
                min-width: 170px;
              }
            }
          }
        }
      }
    }

    .rigth-panel {
      width: 0px;
      height: 100%;
      background: #fff;
      border-left: 1px solid #ddd;
      display: flex;
      flex-direction: column;
      padding: 10px;
    }
  }

  .wrapper-footer {
    height: 65px;
    background: #fff;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 0px 10px;
    border-top: 1px solid #ddd;
  }
}
</style>
